export default "__VITE_ASSET__Cv4TMqu$__"